<template lang='pug'>
.class-container(@click='looking')
    .class-left
        .img-container
            img(v-src='img')
    .class-right
        .top-title {{ title }}
        .desc(v-if='cut == "简介"') 简介: {{ desc }}
        .desc(v-if='cut == "类型"') 类型: {{ cutContent }}
        .time 时间: {{ time }}
        button.yuyue(@click='shoucang', v-if='!isActive') 预约
        button.yuyue(@click='shoucang', v-if='isActive') 已预约
        .button-container(v-if='type == "回看"')
            img(src='@/assets/imgs/回看@3x.png')
            .looking 回看
        .button-container(v-if='type == "查看"')
            img(src='@/assets/imgs/回看@3x.png')
            .looking 查看
</template>

<script>
import { addBookmark, checkMember, deleteBookmark } from '@/service/member'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'ClassItem',
    props: ['time', 'desc', 'title', 'img', 'type', 'cut', 'cutContent', 'link'],
    data() {
        return {
            liveData: [],
            result: false
        }
    },
    computed: {
        ...mapState(['memberInfo', 'bookMarks']),
        isActive() {
            return (this.result && (this.type == '预约'))
        }
    },
    methods: {
        ...mapActions(['getBookmarks']),
        async looking() {
            let isMember = await checkMember(true)
            if (this.link) {
                if (isMember) {
                    window.location.href = this.link
                } else {
                    this.fillForm()
                }
            } else {
                this.$message('该活动已结束')
            }
        },
        fillForm() {
            const { VUE_APP_MEMBER_FORMID, VUE_APP_FORM } = window.env
            window.location.href = `${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${this.$route.fullPath}`
        },
        async shoucang() {
            let isMember = await checkMember(true)
            if (!isMember) {
                this.fillForm()
            }
            if (this.result) {
                await deleteBookmark(this.result.id)
            } else {
                await addBookmark({
                    detail: {
                        name: this.title,
                        time: this.time,
                        img: this.img
                    },
                    name: this.title,
                    url: window.location.href
                })
                window.location.href = this.link
            }
            await this.getBookmarks(true)
            await this.initData()
        },
        async initData() {
            this.liveData = []
            if(!this.bookMarks || this.bookMarks.length == 0){
                return
            }
            this.bookMarks.forEach(val => {
                if (val.detail.type == 'live') {
                    this.liveData.push(val)
                }
            })
            this.result = this.bookMarks.find(val => {
                return val.detail.name == this.title
            })
        }
    },
    created() {
        this.initData()
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.class-container {
    overflow: hidden;
    overflow-y: auto;
    height: 3.9rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 1rem;
    .class-left {
        .img-container {
            width: 6rem;
            height: 3.9rem;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
                border-radius: 0.3rem;
            }
        }
    }
    .class-right {
        margin-left: 0.5rem;

        .top-title {
            width: 10.2rem;
            color: #00448a;
            margin-bottom: 0.15rem;
            height: 1.8rem;
        }
        .desc {
            color: #7b7b7b;
            font-size: 0.6rem;
            .ellipsis;
            margin-bottom: 0.25rem;
            width: 10.2rem;
        }
        .time {
            color: #7b7b7b;
            font-size: 0.6rem;
            width: 10.2rem;
        }
        .button-container {
            // width: 2.45rem;
            height: 1rem;
            background: #219cdc;
            border-radius: 0.2rem;
            font-size: 0.55rem;
            position: absolute;
            bottom: 0;
            right: 0;
            display: flex;
            align-items: center;
            padding: 0 0.35rem;
            color: white;
            img {
                width: 0.4rem;
                height: 0.4rem;
                display: block;
                margin-right: 0.1rem;
            }
        }
        .yuyue {
            // width: 2.45rem;
            height: 1rem;
            background: #219cdc;
            border-radius: 0.2rem;
            font-size: 0.55rem;
            color: white;
            border: none;
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }
}
</style>